/**
 * @generated SignedSource<<2cbaa0cd6dcff19b3ca42fe9d2b9d6a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelImagecardsAllImagesQuery$variables = {
  id: string;
};
export type ModelImagecardsAllImagesQuery$data = {
  readonly model: {
    readonly images: ReadonlyArray<{
      readonly id: string;
    }> | null | undefined;
  } | null | undefined;
};
export type ModelImagecardsAllImagesQuery = {
  response: ModelImagecardsAllImagesQuery$data;
  variables: ModelImagecardsAllImagesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelImage",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ModelImagecardsAllImagesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ModelImagecardsAllImagesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "78a22b1d50e60c09681a4ab5f0f103a9",
    "id": null,
    "metadata": {},
    "name": "ModelImagecardsAllImagesQuery",
    "operationKind": "query",
    "text": "query ModelImagecardsAllImagesQuery(\n  $id: ID!\n) {\n  model(id: $id) {\n    images {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "482b5b57e3bf39edc30b2ac9e0dfbf0d";

export default node;
